import { useMemo } from 'react';

import { useBalanceStore } from '@/entities/balance';
import { useSpace } from '@/entities/teamspace';
import { useSettings } from '@/entities/user/currentUser';

import { useIsSpaceOwner } from './useIsSpaceOwner';

export const useCanInviteMember = (membersCount?: number) => {
  const isOwner = useIsSpaceOwner();
  const { data: space } = useSpace();
  const settings = useSettings();
  const { hasActiveSubscription } = useBalanceStore();

  const canInviteMember = useMemo(() => {
    if (!isOwner) return false;

    const { enabled, metadata } = settings.scope_settings.available_features.spaces;

    if (!enabled || !space || !hasActiveSubscription) return false;

    const spaceCountLimits = metadata.user_limit ?? 0;

    return (membersCount ?? (space?.members?.length ?? 0) + (space?.invites?.length ?? 0)) < spaceCountLimits;
  }, [hasActiveSubscription, isOwner, membersCount, settings.scope_settings.available_features.spaces, space]);

  return canInviteMember;
};
